import React from 'react'
import { updateContactApi } from '../../../../apis/apis'
import { getTenant } from '../Tenants.slice'
import { useParams } from 'react-router-dom'
import InlineEditInput from '../../../../components/Form/InlineEditInput'
import * as Yup from 'yup'
import { formatPhoneNumber } from '../../../../util/string'
import { useAppDispatch } from '../../../../shared/redux/hooks'

export interface PanelContactProps {
  contact?: {
    cuid?: string
    firstName?: string
    lastName?: string
    phone?: string
    emailAddress?: string
  }
}

export const PanelContact: React.FC<PanelContactProps> = (props) => {
  const dispatch = useAppDispatch()
  const { tenantId } = useParams()
  const { contact = {} } = props

  const refreshTenant = async (): Promise<void> => {
    await dispatch(getTenant(tenantId as string))
  }

  return (
    <div className="flex min-w-0 flex-wrap items-center gap-x-1.5 gap-y-0.5">
      <span className="inline-flex min-w-0 items-center gap-1">
        <span className="shrink-0 text-slate-500 dark:text-slate-400">Contact:</span>
        <InlineEditInput
          name="firstName"
          label="First name"
          hideLabel
          fitContent
          compact
          required
          initialValue={contact.firstName}
          handleSubmit={async (editedValue) =>
            await updateContactApi(tenantId as string, contact.cuid ?? '', {
              firstName: editedValue,
            }).then(refreshTenant)
          }
          className="shrink-0 font-medium"
        />
        <InlineEditInput
          name="lastName"
          label="Last name"
          hideLabel
          fitContent
          compact
          required
          initialValue={contact.lastName}
          handleSubmit={async (editedValue) =>
            await updateContactApi(tenantId as string, contact.cuid ?? '', {
              lastName: editedValue,
            }).then(refreshTenant)
          }
          className="shrink-0 font-medium"
        />
      </span>
      <span className="text-slate-300 dark:text-slate-600" aria-hidden>
        ·
      </span>
      <span className="inline-flex min-w-0 items-center gap-1">
        <span className="shrink-0 text-slate-500 dark:text-slate-400">Phone:</span>
        <InlineEditInput
          name="phone"
          label="Phone"
          hideLabel
          fitContent
          compact
          required
          initialValue={contact.phone}
          validationSchema={Yup.string().test('phone', '10 digits required', (value): boolean => {
            return value?.replace(/\D/g, '').match(/^\d{10}$/) !== null
          })}
          formatter={formatPhoneNumber}
          handleSubmit={async (editedValue) =>
            await updateContactApi(tenantId as string, contact.cuid ?? '', {
              phone: editedValue,
            }).then(refreshTenant)
          }
          className="shrink-0 font-medium"
        />
      </span>
      <span className="text-slate-300 dark:text-slate-600" aria-hidden>
        ·
      </span>
      <span className="inline-flex min-w-0 max-w-full items-center gap-1">
        <span className="shrink-0 text-slate-500 dark:text-slate-400">Email:</span>
        <InlineEditInput
          name="emailAddress"
          label="Email"
          hideLabel
          fitContent
          compact
          required
          validationSchema={Yup.string().email('Invalid email')}
          initialValue={contact.emailAddress}
          handleSubmit={async (editedValue) =>
            await updateContactApi(tenantId as string, contact.cuid ?? '', {
              emailAddress: editedValue,
            }).then(refreshTenant)
          }
          className="min-w-0 max-w-[18rem] truncate font-medium"
        />
      </span>
    </div>
  )
}

export default PanelContact
